/**
 * Rarest Watches — collection toolbar (columns + grid/list + brand filter).
 * Sort is native Shopify via ?sort_by= form submit.
 */
(function () {
  'use strict';

  var COL_KEY = 'rw_collection_cols';
  var VIEW_KEY = 'rw_collection_view';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function applyColumns(grid, n) {
    if (!grid) return;
    grid.setAttribute('data-rw-cols', String(n));
    grid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop', 'grid--5-col-desktop');
    if (n === 3) grid.classList.add('grid--3-col-desktop');
    else grid.classList.add('grid--4-col-desktop');
    try { localStorage.setItem(COL_KEY, String(n)); } catch (e) {}
    qsa('[data-rw-cols-btn]').forEach(function (btn) {
      var on = Number(btn.getAttribute('data-rw-cols-btn')) === n;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
  }

  function applyView(grid, view) {
    if (!grid) return;
    grid.setAttribute('data-rw-view', view);
    grid.classList.toggle('product-grid--list', view === 'list');
    grid.classList.toggle('product-grid--grid', view !== 'list');
    try { localStorage.setItem(VIEW_KEY, view); } catch (e) {}
    qsa('[data-rw-view-btn]').forEach(function (btn) {
      var on = btn.getAttribute('data-rw-view-btn') === view;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
  }

  function initToolbar() {
    var root = qs('[data-rw-collection-tools]');
    var grid = qs('[data-rw-collection-grid]');
    if (!root || !grid) return;

    var cols = 4;
    var view = 'grid';
    try {
      cols = Number(localStorage.getItem(COL_KEY)) || 4;
      view = localStorage.getItem(VIEW_KEY) || 'grid';
    } catch (e) {}
    if (cols === 2) cols = 4;
    if ([3, 4].indexOf(cols) === -1) cols = 4;
    if (view !== 'list') view = 'grid';

    applyColumns(grid, cols);
    applyView(grid, view);

    root.addEventListener('click', function (e) {
      var colBtn = e.target.closest('[data-rw-cols-btn]');
      if (colBtn) {
        e.preventDefault();
        applyColumns(grid, Number(colBtn.getAttribute('data-rw-cols-btn')));
        return;
      }
      var viewBtn = e.target.closest('[data-rw-view-btn]');
      if (viewBtn) {
        e.preventDefault();
        applyView(grid, viewBtn.getAttribute('data-rw-view-btn'));
      }
    });

    var sort = qs('[data-rw-sort]', root);
    if (sort) {
      sort.addEventListener('change', function () {
        if (sort.form) sort.form.submit();
      });
    }
  }

  function initBrandFilter() {
    var root = qs('[data-rw-collection-tools]');
    var grid = qs('[data-rw-collection-grid]');
    var sheet = qs('[data-rw-filter]');
    if (!root || !grid || !sheet) return;

    var listEl = qs('[data-rw-brand-list]', sheet);
    var noneEl = qs('[data-rw-brand-none]', sheet);
    var badge = qs('[data-rw-filter-badge]', root);
    var emptyEl = qs('[data-rw-filter-empty]');
    var countEl = qs('.collection-toolbar__count', root);
    var isCollectibles = /collectibles/i.test(window.location.pathname);
    var selected = [];

    function rebuildBrandsFromGrid() {
      if (!listEl) return;
      var map = {};
      qsa('.grid__item[data-rw-brand]', grid).forEach(function (li) {
        var key = (li.getAttribute('data-rw-brand') || '').trim().toLowerCase();
        var label = (li.getAttribute('data-rw-brand-label') || '').trim();
        if (!key) return;
        if (!label) label = key;
        if (!map[key]) map[key] = label;
      });
      var keys = Object.keys(map).sort(function (a, b) {
        return map[a].toLowerCase().localeCompare(map[b].toLowerCase());
      });
      listEl.innerHTML = keys.map(function (key) {
        var label = map[key];
        return (
          '<li><label class="rw-filter__option">' +
            '<input type="checkbox" name="rw_brand" value="' + label.replace(/"/g, '&quot;') + '" data-rw-brand-option data-rw-brand-key="' + key.replace(/"/g, '&quot;') + '">' +
            '<span class="rw-filter__check" aria-hidden="true"></span>' +
            '<span class="rw-filter__name">' + label.replace(/</g, '&lt;') + '</span>' +
          '</label></li>'
        );
      }).join('');
      if (noneEl) noneEl.hidden = keys.length > 0;
    }

    function openSheet() {
      /* list already built on init — only sync checks, then animate */
      syncChecksFromSelected();
      sheet.hidden = false;
      document.documentElement.classList.add('rw-filter-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sheet.classList.add('is-open');
        });
      });
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('rw-filter-open');
      setTimeout(function () { sheet.hidden = true; }, 230);
    }

    function optionKey(el) {
      return (el.getAttribute('data-rw-brand-key') || String(el.value || '')).trim().toLowerCase();
    }

    function readChecks() {
      return qsa('[data-rw-brand-option]:checked', sheet).map(optionKey).filter(Boolean);
    }

    function syncChecksFromSelected() {
      qsa('[data-rw-brand-option]', sheet).forEach(function (el) {
        el.checked = selected.indexOf(optionKey(el)) !== -1;
      });
    }

    function updateBadge() {
      if (!badge) return;
      if (selected.length) {
        badge.hidden = false;
        badge.textContent = String(selected.length);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
      var openBtn = qs('[data-rw-filter-open]', root);
      if (openBtn) openBtn.classList.toggle('is-active', selected.length > 0);
    }

    function countLabel(n) {
      if (isCollectibles) return n === 1 ? '1 rarity' : (n + ' rarities');
      return n === 1 ? '1 timepiece' : (n + ' timepieces');
    }

    function applyFilter() {
      var items = qsa('.grid__item[data-rw-brand]', grid);
      var shown = 0;
      items.forEach(function (li) {
        var brand = (li.getAttribute('data-rw-brand') || '').trim().toLowerCase();
        var ok = !selected.length || selected.indexOf(brand) !== -1;
        li.hidden = !ok;
        if (ok) shown += 1;
      });
      if (emptyEl) emptyEl.hidden = !(selected.length && shown === 0);
      updateBadge();
      if (countEl) {
        var base = countEl.getAttribute('data-rw-count-base');
        if (!base) {
          base = countEl.textContent.trim();
          countEl.setAttribute('data-rw-count-base', base);
        }
        countEl.textContent = selected.length ? countLabel(shown) : base;
      }
      try {
        var storageKey = isCollectibles ? 'rw_brand_filter_collectibles' : 'rw_brand_filter';
        if (selected.length) sessionStorage.setItem(storageKey, JSON.stringify(selected));
        else sessionStorage.removeItem(storageKey);
      } catch (e) {}
    }

    function clearFilter() {
      selected = [];
      syncChecksFromSelected();
      applyFilter();
    }

    rebuildBrandsFromGrid();

    try {
      var storageKey = isCollectibles ? 'rw_brand_filter_collectibles' : 'rw_brand_filter';
      var saved = sessionStorage.getItem(storageKey);
      if (saved) {
        selected = JSON.parse(saved) || [];
        if (!Array.isArray(selected)) selected = [];
        selected = selected.map(function (s) { return String(s).trim().toLowerCase(); });
        syncChecksFromSelected();
        applyFilter();
      }
    } catch (e) {}

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-rw-filter-open]')) {
        e.preventDefault();
        openSheet();
      }
    });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-rw-filter-close]')) {
        e.preventDefault();
        closeSheet();
        return;
      }
      if (e.target.closest('[data-rw-filter-clear]')) {
        e.preventDefault();
        clearFilter();
        return;
      }
      if (e.target.closest('[data-rw-filter-apply]')) {
        e.preventDefault();
        selected = readChecks();
        applyFilter();
        closeSheet();
      }
    });

    document.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('[data-rw-filter-clear]');
      if (clearBtn && !clearBtn.closest('[data-rw-filter]')) {
        clearFilter();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  }

  function init() {
    initToolbar();
    initBrandFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
